module.exports = __webpack_public_path__ + "img/notes-icon.c95518e3.png";